import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWifi, faTimes } from "@fortawesome/free-solid-svg-icons";
import styles from "./DisconnectionNotification.module.css";

export const DisconnectionNotification = ({
  playerName,
  onDismiss,
  duration = 5000,
  gameMode = "survival",
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        const newProgress = prev - 100 / (duration / 100);
        return Math.max(0, newProgress);
      });
    }, 100);

    const dismissTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onDismiss?.(), 300); // Allow fade-out animation
    }, duration);

    return () => {
      clearInterval(progressInterval);
      clearTimeout(dismissTimer);
    };
  }, [duration, onDismiss]);

  const handleDismiss = () => {
    setIsVisible(false);
    setTimeout(() => onDismiss?.(), 300);
  };

  const getGameModeContext = (mode) => {
    switch (mode) {
      case "time_attack":
        return "The game will continue with remaining players.";
      case "survival":
        return "They have been eliminated from the survival challenge.";
      case "speed_battle":
        return "The speed battle continues with remaining players.";
      default:
        return "The game continues with remaining players.";
    }
  };

  if (!isVisible) return null;

  return (
    <div
      className={`${styles.notification} ${
        isVisible ? styles.visible : styles.hidden
      }`}
    >
      <div className={styles.notificationContent}>
        <div className={styles.header}>
          <div className={styles.iconSection}>
            <FontAwesomeIcon icon={faWifi} className={styles.disconnectIcon} />
          </div>
          <div className={styles.messageSection}>
            <h4 className={styles.title}>Player Disconnected</h4>
            <p className={styles.playerName}>
              <strong>{playerName}</strong> has left the game
            </p>
            <p className={styles.context}>{getGameModeContext(gameMode)}</p>
          </div>
          <button className={styles.dismissButton} onClick={handleDismiss}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Progress bar */}
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};
